import { Card, Link, Typography } from "@mui/joy";
import React from "react";
import "./Registry.css";

function Registry() {
    return (
        <Card className="registry-card">
            <Typography level="h1" className="title">
                Registry
            </Typography>

            <Typography level="body-lg" className="paragraph">
                Your presence at our wedding is the greatest gift of all. However, if you wish to honor us with a gift, we have registered at the following link:
            </Typography>

            <ul className="registry-list">
                <li>
                    <Link href="https://www.amazon.com/wedding/share/davidandtala" target="_blank" rel="noopener noreferrer">
                        Amazon - David & Tala's Registry
                    </Link>
                </li>
            </ul>

            <Typography level="body-lg" className="paragraph">
                Thank you for your love and support as we begin this new chapter together.
            </Typography>
        </Card>
    );
}

export default Registry;
